export default __webpack_public_path__ + "static/media/Gauntlets of the Valiant.7d29d855.jpg";